import {Canvas} from '@react-three/fiber'
import {Physics} from '@react-three/rapier'
import {GameScene} from './components/GameScene'
import {UI} from './components/UI'
import {SimpleFallback} from './components/SimpleFallback'
import {GameProvider} from './contexts/GameContext'

function App() {
    // Удаляем isMobile и devicePixelRatio
    const canvas = document.createElement('canvas')
    const webglSupported = !!(canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))

    // Показываем 3D если WebGL поддерживается, иначе 2D
    if (!webglSupported) {
        return (
            <GameProvider>
                <div className="game-container">
                    <SimpleFallback/>
                </div>
            </GameProvider>
        )
    }

    return (
        <GameProvider>
            <div className="game-container">
                <Canvas
                    camera={{
                        position: [0, 1.5, -15], // Further behind ball, looking towards goal
                        fov: 75,
                        near: 0.1,
                        far: 1000,
                    }}
                    onCreated={({camera}) => {
                        camera.lookAt(0, 1, 0);
                    }}
                    gl={{
                        antialias: false, // Disable antialiasing for mobile
                        alpha: true,
                        powerPreference: "high-performance",
                        stencil: false,
                        depth: true,
                    }}
                    frameloop="always"
                    dpr={[1, 2]} // Limit DPR for performance
                    performance={{
                        min: 0.5,
                    }}
                >
                    <Physics
                        debug={false}
                        gravity={[0, -9.81, 0]}
                        interpolate={true}
                        timeStep={1 / 60} // Fixed time step
                    >
                        <GameScene/>
                    </Physics>
                </Canvas>
                <UI/>
            </div>
        </GameProvider>
    )
}

export default App
